import "./Equipo.css";
import { AiOutlineTeam } from "react-icons/ai";
import React, { useState, useEffect } from "react";
import CargandoSpinner from "../../0. Utilidades/loadingSpinner"; // Import the spinner component

const EquipoModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [profesionales, setProfesionales] = useState([]);

  useEffect(() => {
    if (isOpen) {
      const apiUrl = `${process.env.REACT_APP_BASE_API}api/perfiles/profesionales/?equipo=true`;

      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => setProfesionales(data))
        .catch((error) =>
          console.error("Error fetching profesionales:", error),
        );
    }
  }, [isOpen]);

  return (
    <div id="equipo">
      <button
        onClick={() => setIsOpen(true)}
        style={{ background: "none", border: "0" }}
      >
        <AiOutlineTeam /> Revisar Equipo
      </button>

      {isOpen && (
        <div className="modal-overlay" onClick={() => setIsOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Equipo RedMaestra</h2>
            <div className="profesional-list">
              {profesionales.length > 0 ? (
                profesionales.map((profesional) => (
                  <div key={profesional.id} className="profesional-card">
                    <img
                      src={profesional.imagen || "/static/images/default.png"}
                      alt={profesional.nombre}
                      className="profesional-image"
                    />
                    <div className="profesional-info">
                      <h3>{profesional.nombre}</h3>
                      <p>
                        <strong>👤 Usuario:</strong>{" "}
                        {profesional.user?.username || "No asignado"}
                      </p>
                      <p>
                        {profesional.user?.email ? (
                          <a
                            href={`mailto:${profesional.user.email}`}
                            className="email-link"
                          >
                            {profesional.user.email}
                          </a>
                        ) : (
                          "No disponible"
                        )}
                      </p>
                      <p>
                        <strong>📞</strong>{" "}
                        {profesional.celular ? (
                          <a
                            href={`tel:${profesional.celular}`}
                            className="phone-link"
                          >
                            {profesional.celular}
                          </a>
                        ) : (
                          "No disponible"
                        )}
                      </p>
                      <p>
                        <strong>👥 Roles:</strong>
                      </p>
                      <div className="group-badges">
                        {profesional.groups.length > 0 ? (
                          profesional.groups.map((group, index) => (
                            <span
                              key={index}
                              className="group-badge"
                              style={{ backgroundColor: group.color }}
                            >
                              {group.name}
                            </span>
                          ))
                        ) : (
                          <span className="group-badge no-group">
                            No asignado
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <CargandoSpinner />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EquipoModal;
